import PageHeader from './components/PageHeader/PageHeader'
import FeaturedPosts from './components/FeaturedPosts/FeaturedPosts'
import SlimBanner from './components/SlimBanner/SlimBanner'
import CollectionBlocks from './components/CollectionBlocks/CollectionBlocks'
import PageFooter from './components/PageFooter/PageFooter'

import './App.scss'

import { slugify } from './helpers/helpers'

let slug = window.location.pathname.split('/').pop()

if (slug.indexOf('shop-') !== -1) {
    slug = slug.replace('shop-', '')
}

console.log('slug', slug)

let jsonData = {}

if (slug === 'pregnancy' || slug ==='maternity') {
    jsonData = require('./data/shop_maternity_data.json')
} else if (slug === 'newborn' || slug === 'baby') {
    jsonData = require('./data/shop_baby_data.json')
} else if (slug === 'toddler' || slug === 'toddler-kids') {
    jsonData = require('./data/shop_toddler_data.json')
} else if (slug === 'kids') {
    jsonData = require('./data/shop_toddler_data.json')
} else if (slug === 'gifts') {
    jsonData = require('./data/shop_gifts_data.json')
} else {
    jsonData = require('./data/shop_maternity_data.json')
}

const loadData = () => JSON.parse(JSON.stringify(jsonData))
const loadedData = loadData()

console.log('loadedData', loadedData)

const pageSlug = slugify(loadedData.pageName)
const modules = loadedData.modules

let pageHeader
let featuredPosts
let collectionBlocks
let pageFooter

modules.map((m) => {
    if (m.module === 'Page Header') {
        pageHeader = m
    }
    if (m.module === 'Featured Posts') {
        featuredPosts = m
        // console.log('featuredCollections', featuredCollections)
    }
    if (m.module === 'Collection Blocks') {
        collectionBlocks = m
    }
    if (m.module === 'Page Footer') {
        pageFooter = m
    }
    return null
})

const App = () => {
    return (
        <div id="top-of-page" className={`App Segment-Hub-Page ${pageSlug}`}>
            {pageHeader ? (
                <PageHeader data={pageHeader} />
            ) : (
                <div className="loading">Loading...</div>
            )}
            {/* {featuredPosts ? (
                <FeaturedPosts data={featuredPosts} />
            ) : (
                <div className="loading">Loading...</div>
            )} */}
            {collectionBlocks ? (
                <CollectionBlocks data={collectionBlocks} />
            ) : (
                <div className="loading">Loading...</div>
            )}
            {pageFooter ? (
                <PageFooter data={pageFooter} />
            ) : (
                <div className="loading">Loading...</div>
            )}
        </div>
    )
}

export default App
